export default class PageShare {
    constructor(el){
        this.el         = el;
        this.wrapper    = this.el.find('.page__share');
        this.facebook   = this.el.find('.page__share__facebook');
        this.twitter    = this.el.find('.page__share__twitter');
        this.linkedin   = this.el.find('.page__share__linkedin');
        
        this.events();
    }

    events(){
      this.shareIt();
    }

    shareIt(){          
                  
      setTimeout(()=>{

          const   $addThisContainer    = $('.at-resp-share-element'),
                  $addThisFb           = $addThisContainer.find('.at-svc-facebook span'),
                  $addThisTw           = $addThisContainer.find('.at-svc-twitter  span'),
                  $addThisLn           = $addThisContainer.find('.at-svc-linkedin span');
                  
          if($addThisContainer.length){

            this.facebook.click(function(){                
                  $addThisFb.click();                
              });        
              this.twitter.click(function(){                
                  $addThisTw.click();
              });        
              this.linkedin.click(function(){                
                  $addThisLn.click();                    
              });
              
          }

      },1000);   
    }    
}